import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { Categories } from '../../../interfaces/categories';
import { Paises } from '../../../interfaces/paises';
import { AuthService } from '../../../services/auth.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { PaisesModel } from '../../../models/paises';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { GeneralGestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';
import { map } from 'rxjs/operators';
declare let $: any;

@Component({
    selector: 'app-identification-data',
    templateUrl: './identification-data.component.html',
    styleUrls: ['./identification-data.component.scss']
})
@AutoUnsubscribe()
export class IdentificationDataComponent implements OnInit, OnDestroy{

    @Input() cargarVista: string;
    @Input() formMode: boolean;
    @Input() modoEdicion: boolean;

    categories: Categories[];
    auxCtipoCliente: string;
    newPaises: Paises[] = [];
    placeholderaddress: string;
    placeholderarcadCode: string;
    public comboCustomerCategorias: Array<any> = [];
    pais: string;
    PaisCodeCustomer: Paises;
    cliente: boolean;
    aseguradora: boolean;
    proveedor: boolean;
    proveedorMarca: boolean;
    sucursal: boolean;
    customerTipe: string;
    voClientes: boolean;
    pulsadoCustomerType: boolean;
    isCreadoCustomer: Subscription;
    datosPrincipales: Subscription;
    datosIdentificacion: Subscription;
    textObligado: string;
    auxTipoCliente: any;
    auxArcade: string;
    defaultCustomerType: any;
    error: string;
    code: string;
    codigoPostalSugerencia: any[];
    showModalArcade: boolean = false;
    containResultsList = false;
    listDataCity = [];

    constructor(
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        private translateService: TranslateService,
        private _authService: AuthService,
        public _gestionTercerosService: GestionTercerosService
    ) {
        this.placeholderaddress = '';
        this.placeholderarcadCode = '';
        this.defaultCustomerType = { value: '**', text: 'Seleccionar' };
        this.pulsadoCustomerType = false;
    }
    ngOnDestroy(): void {
        this._gestionTercerosService.sePuedeDesactivar = false;
        this._gestionTercerosService.revocaDate = null;
    }

    ngOnInit() {
        this.translateService.get('errors.required.campoObligatorio').subscribe(text => {
            this.textObligado = text;
        });
        this.blurElementDatosDatosIdentificacion('address');
        if (this.cargarVista === 'gestionTerceros') {
            this.voClientes = false;
        } else if (this.cargarVista === 'voClientes') {
            this.voClientes = true;
        }
        this.pais = this._authService.getDataPais();

        this.comboCategorias();
        this.comboPaises();

        ///Comprobamos aqui los checkBox
        if (this.pais === 'fr') {
            this.comboCustomerCategorias = [
                { value: '**', text: 'Seleccionar' },
                { value: 'C', text: 'Client' },
                { value: 'S', text: 'Fournisseur' },
                { value: 'B', text: 'Client/Fournisseur' },
                { value: 'A', text: 'Client/Assurance' },
                { value: 'R', text: 'Client/Sucursal' },
                { value: 'L', text: 'Fournisseur/Sucursal' },
                { value: 'M', text: 'Client/Fournisseur/Sucursal' }
            ];
        } else if (this.pais === 'pt'){
            this.comboCustomerCategorias = [
                { value: '**', text: 'Selecionar' },
                { value: 'C', text: 'Cliente' },
                { value: 'S', text: 'Fornecedor' },
                { value: 'B', text: 'Cliente/Fornecedor' },
                { value: 'A', text: 'Cliente/Seguradora' }
            ];
        } else {
            this.comboCustomerCategorias = [
                { value: '**', text: 'Seleccionar' },
                { value: 'C', text: 'Cliente' },
                { value: 'S', text: 'Proveedor' },
                { value: 'B', text: 'Cliente/Proveedor' },
                { value: 'A', text: 'Cliente/Aseguradora' }
            ];
        }

        this.auxArcade = this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('arcadCode').value;
        if (this.auxArcade) {
            this.proveedorMarca = true;
        } else {
            this.proveedorMarca = false;
        }

        this.isCreadoCustomer = this._gestionTercerosService.observerCreadoCustomer().subscribe(val => {
            if (val === true) {
                this.comprobarPestana();
            }
        });

        this.comprobarPestana();

        this._gestionTercerosService.customerForm.controls.datosIdentificacion.valueChanges.subscribe(val => {
            this.comprobarPestana();
        });
    }

    changesPostalData(val){
        const paisSelector = this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').value.CountryCode;
        if(this.pais === 'pt' && paisSelector !== 'PT' && paisSelector !== 'ES'){
            // en el caso de que el pais sea PT y el selector de pais distinto de PT y ES no hace validacion del codigo postal
        }else{
            if (val !== '' && val.length > 4) {
                let IsoCode2 = this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('pais').value;
                const b = { searchValue: val, 'isoCode': IsoCode2.CountryCode };

                switch (this.pais) {
                    case 'es':
                    case 'pt':
                        this.validacionPostal(b);
                        break;
                    case 'fr':
                        // no se valida
                        break;
                }
            }
        }
    }

    validacionPostal(codigoPostal) {
        const _URL_ = `${environment.ENTORNO}Services/General/PostalCodesService.svc/GetByCapCode`;

        let City: 'VITORIA-GASTEIZ'; //  city: new FormControl(''),
        let ProvinceDescription: 'ÁLAVA'; // province: new FormControl(''),
        let IsoCode: 'ES'; // pais: new FormControl({   CountryCode: 'ES',  Name: null} ),
        let Pais = { CountryCode: '', Name: null };

        this._generalGestionTercerosService.getByCapCode(_URL_, codigoPostal).subscribe(data => {

            this.containResultsList = false;

            // List of results
            if (data && Array.isArray(data.contents) && data.contents.length > 1) {
                this.containResultsList = true;
                this.listDataCity = data.contents;
            }

            const auxdata = data.contents[0];
            if (auxdata) {
                this.codigoPostalSugerencia = auxdata;
                ProvinceDescription = auxdata.Province.Description;
                City = auxdata.City;
                IsoCode = auxdata.Province.IsoCode;
                Pais = { CountryCode: IsoCode, Name: null };
                this._gestionTercerosService.customerForm.get('datosIdentificacion').get('province').setValue(ProvinceDescription, { emitEvent: false });
                this._gestionTercerosService.customerForm.get('datosIdentificacion').get('city').setValue(City, { emitEvent: false });
                this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').setValue(Pais, { emitEvent: false });
            }

        });

    }

    comprobarPestana() {
        const pestanaDatosIdentificacion = this._gestionTercerosService.customerForm.controls.datosIdentificacion.valid;
        // no detecta error en los selectores porque tienen valor , añado validacion

        if (pestanaDatosIdentificacion) {
            $('#identificacion').parent().parent().find('li.k-state-active').removeClass('pestana_error');
        } else {
            $('#identificacion').parent().parent().find('li.k-state-active').addClass('pestana_error');
        }

        // El check que se hacia para poner la clase de invalida al formulario de gestion no vale ya que el id del div que se busca
        // no existe al estar dentro de un ngif, este nuevo check funciona siempre y cuando no haya mas componentes de pestañas
        // $('#gestion').parent().parent().find('li.k-state-active').addClass('pestana_error');
        if (this._gestionTercerosService.customerForm && this._gestionTercerosService.customerForm.get('gestion') && this._gestionTercerosService.customerForm.get('gestion').get('PaymentCode')) {
            if (this._gestionTercerosService.customerForm.get('gestion').get('PaymentCode').value === '***') {
                $('#k-tabstrip-tab-3').addClass('pestana_error');
            } else {
                $('#k-tabstrip-tab-3').removeClass('pestana_error');
            }
        }
    }

    public valueChangeCT(value: any): void {
        this.pulsadoCustomerType = true;
        if (value.value === '**') {
            this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerType').setErrors({ 'invalid': true });
        } else {
            // Si pulsamos el selector de customerType entonces el campo customerCategory es obligatorio
            this.setValidatorRequired('customerCategory', Validators.required);
        }
        if (value.value === 'S' || value.value === 'L') {
            this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerCategory').setValue({CUSTOMERCATEGORY: '**', Description: ''});
            this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerCategory').clearValidators();
            this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerCategory').updateValueAndValidity();
        } else {
            this.valueChangeCC(this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerCategory').value);
        }
        this.comprobarPestana();
    }

    public valueChangeCC(value: any): void {
        if (value.CUSTOMERCATEGORY === '**') {
            this._gestionTercerosService.customerForm.get('datosIdentificacion').get('customerCategory').setErrors({ 'invalid': true });
        }
        this.comprobarPestana();
    }

    comboCategorias() {
        const parametros = '';
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_CustomerCategory}${environment.SessionService.ENDPOINT.GetAll}`;
        this._generalGestionTercerosService.getCustomerCategories(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.categories = auxdata;
            }
        });
    }

    comboPaises() {
        const parametros = '';
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_ISOCodesService}${environment.SessionService.ENDPOINT.GetAll}`;
        this._generalGestionTercerosService.getCustomerPaises(_URL_, parametros).pipe(
            map((paises: any) => {
                return paises.Response.map((item, i) => {
                    let paisList = new PaisesModel();
                    paisList.CountryCode = item.ISOCODE;
                    paisList.Name = item.Description;
                    return paisList;
                });

            })).subscribe(data => {
                this.newPaises = data;
                this.buscarCountry();
            });
    }

    public valueChangePais(value: any): void {
        this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').setValue(value, { emitEvent: false });
    }

    buscarCountry() {
        const auxCode = this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').value;
        this.PaisCodeCustomer = this.newPaises.find(item => item.CountryCode === auxCode.CountryCode.toUpperCase());
    }

    closeModalArcade(result) {
        if (result.LinkedCode) {
            this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('arcadCode').setValue(result.LinkedCode);
        }
        this.showModalArcade = false;
    }

    openModalArcade() {
        this.showModalArcade = true;
    }

    selectProveedorMarca(proveedorMarca) {
        this.proveedorMarca = proveedorMarca.currentTarget.checked;
        if (this.proveedorMarca) {
            this.setValidatorRequired('arcadCode', Validators.required);
        } else {
            this.setValidatorRequired('arcadCode', null);
        }
    }

    selectRegimenIva(regimen) {
        const auxValor = regimen.currentTarget.checked;
        if (auxValor) {
            this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('VATRegime').setValue('RC');
        } else {
            this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('VATRegime').setValue('GE');
        }
    }

    checkboxIntraCommunity(value) {
        const auxValor = value.currentTarget.checked;
        this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('IntraCommunity').setValue(auxValor);
    }

    setValidatorRequired(campo, requerido) {
        this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(campo).setValidators(requerido);
        this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(campo).updateValueAndValidity();
    }

    hasError(name) {
        return this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(name).hasError('required') && this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(name).touched;
    }

    getValueControl(name) {
        return this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(name).value === ''
            || this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(name).value === null
            || this._gestionTercerosService.customerForm.controls.datosIdentificacion.get(name).value === '**';
    }

    getValueCustomerCategory() {
        if (this.cargarVista != 'voClientes') {
            if (this.pulsadoCustomerType) {
                const customerType = this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').value;
                const auxValor = this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerCategory').value.CUSTOMERCATEGORY;
                if(customerType === 'S' || customerType === 'L'){
                    return false;
                }
                else return auxValor === '**' || auxValor === null;
            }
        } else {
            const auxValor = this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerCategory').value.CUSTOMERCATEGORY;
            return auxValor === '**' || auxValor === null;
        }
    }

    blurElementDatosDatosIdentificacion(name) {
        if (this._gestionTercerosService.customerForm.get('datosIdentificacion').get(name).value === '' || this._gestionTercerosService.customerForm.get('datosIdentificacion').get(name).value === null) {
            switch (name) {
                case 'address':
                    this.placeholderaddress = this.textObligado;
                    break;
                case 'arcadCode':
                    this.placeholderarcadCode = this.textObligado;
                    break;
            }
        } else {
            this.placeholderaddress = '';
            this.placeholderarcadCode = '';
        }
    }

}
